import axios from "axios";
import { Base64 } from "js-base64";
import { ROUTES } from "../../../../constants";

// Actions

export const FETCH_GDPR_PROMPT_REQUEST = "gdpr/FETCH_GDPR_PROMPT_REQUEST";
export const FETCH_GDPR_PROMPT_FAILURE = "gdpr/FETCH_GDPR_PROMPT_FAILURE";
export const FETCH_GDPR_PROMPT_SUCCESS = "gdpr/FETCH_GDPR_PROMPT_SUCCESS";

// Reducer
const initialState = {
  error: null,
  loading: true
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    // Initial prompt data.
    case FETCH_GDPR_PROMPT_REQUEST:
      return { ...state, loading: true };
    case FETCH_GDPR_PROMPT_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        ...action.payload
      };
    case FETCH_GDPR_PROMPT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}

// Action Creators
export const fetchGdprPromptRequest = () => ({
  type: FETCH_GDPR_PROMPT_REQUEST
});

export const fetchGdprPromptFailure = error => ({
  type: FETCH_GDPR_PROMPT_FAILURE,
  payload: error
});

export const fetchGdprPromptSuccess = data => ({
  type: FETCH_GDPR_PROMPT_SUCCESS,
  payload: data
});

export const fetchGdprPrompt = (platform = "ehost") => async (
  dispatch,
  getState
) => {
  const {
    intl: { locale, isHindiLang },
    paths: { api, publicApi },
    router: {
      location: { pathname = "" }
    }
  } = getState();
  dispatch(fetchGdprPromptRequest());
  let language = locale;
  try {
    //For data retention scenario, call different URL to get User context
    if (isHindiLang) {
      language = "en";
    }
    const response = await axios.get(
      `${pathname === ROUTES.DATA_RETENTION ? api : publicApi}/gdprPrompt`,
      {
        params: {
          language,
          platform
        }
      }
    );
    dispatch(fetchGdprPromptSuccess(response.data));
  } catch (error) {
    dispatch(fetchGdprPromptFailure(error));
  }
};

/// Selectors
export const getGdprPromptText = state => {
  const prompt = state.gdpr.prompt.prompt || "";
  return Base64.decode(prompt);
};

export const getGdprPromptError = state => state.gdpr.prompt.error;

export const getGdprPromptLoading = state => state.gdpr.prompt.loading;

export const getGdprResponseLabelTrue = state =>
  state.gdpr.prompt.validResponseObj?.response_label_true;

export const getGdprPromptId = state => state.gdpr.prompt.promptId;

export const getGdprPromptLocale = state => state.gdpr.prompt.language;
